import { createMiddlewareAction } from './createMiddlewareAction'
import { endpointsContacts } from '../api/endpoints'
import { contactsTypes } from '../constantes/actionTypes'

export const contactsActions = {
  getAllContacts: () =>
    createMiddlewareAction({
      successType: contactsTypes.GET_ALL_CONTACTS_SUCCESS,
      failureType: contactsTypes.GET_ALL_CONTACTS_FAILURE,
      method: 'GET',
      endpoint: endpointsContacts.GET_ALL_CONTACTS,
    }),
  newContact: (body) =>
    createMiddlewareAction({
      successType: contactsTypes.NEW_CONTACT_SUCCESS,
      failureType: contactsTypes.NEW_CONTACT_FAILURE,
      method: 'POST',
      endpoint: endpointsContacts.NEW_CONTACTS,
      body,
    }),
  updateContact: (body) => ({
    type: contactsTypes.UPDATE_CONTACT_SUCCESS,
    payload: body,
  }),
  deleteContact: (idContact) => ({
    type: contactsTypes.DELETE_CONTACT_SUCCESS,
    payload: idContact,
  }),
}
